<template>
    <div class="registry-wrapper">
        <!-- TABELA -->
        <container-loader v-if="isLoading && !$store.getters.isLoading" />
        <empty-table-message v-if="isEmpty" />

        <b-table v-else class="data-table" :data="anexos" @sort="sortTable" backend-sorting>
            <b-table-column
                v-for="(f, i) in fields"
                :key="i"
                :field="f.field"
                :label="$t(f.key)"
                :width="f.width"
                :sortable="f.sortable"
                v-slot="props"
            >
                <div v-if="f.field == 'datahora'">
                    {{ props.row[f.field] | moment('L') }}
                </div>
                <div v-else-if="f.field == 'nome'">
                    {{ props.row[f.field] }}
                </div>
                <div
                    v-else-if="
                        f.field == 'caminho' &&
                        props.row[f.field] &&
                        ['jpg', 'jpeg', 'png'].includes(
                            props.row['nome']
                                .split('.')
                                [props.row['nome'].split('.').length - 1].toLowerCase()
                        )
                    "
                >
                    <a :href="props.row[f.field]" target="_blank">
                        <img
                            :src="props.row[f.field]"
                            class="img-anexo"
                            :title="props.row['nome']"
                            :alt="props.row['nome']"
                        />
                    </a>
                </div>
                <div v-else>
                    <a :href="props.row[f.field]" target="_blank">
                        <img
                            :src="require('@/assets/img/file.png')"
                            class="img-anexo"
                            :title="props.row['nome']"
                            :alt="props.row['nome']"
                        />
                    </a>
                </div>
            </b-table-column>
        </b-table>
        <PaginationViewer
            class="mb-0"
            :resetPagination="pagination.resetPagination"
            :totalItems="pagination.totalRows"
            :perPageOptions="pagination.perPageOptions"
            :optionStarted="pagination.optionStarted"
            @change="updatePagination"
        />
    </div>
</template>

<script>
import AnexoService from '@/services/agro/ocorrencia/AnexoService';
import ContainerLoader from '@/components/content/loader/ContainerLoader';

export default {
    components: {
        ContainerLoader,
    },
    props: {
        idagro_ocorrencia: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            service: new AnexoService(this.$http, this.$router),
            anexos: [],
            msgs: [],
            fields: [
                { key: 'arquivo', field: 'caminho', sortable: false },
                { key: 'nome', field: 'nome', sortable: true },
                { key: 'datahora', field: 'datahora', sortable: true },
            ],
            permissao: false,
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            column: 'arquivo',
            order: 'asc',
            isEmpty: false,
            isLoading: false,
            abrev: this.$route.meta.contexto.slice(0,4),
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        this.carregarDados();
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + '-aba-anexoocorrencia-' + numberId;
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.isLoading = true;

            this.service
                .findAll(
                    this.column,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.abrev,
                    this.idagro_ocorrencia
                )
                .then(this.mapItems)
                .then((value) => {
                    this.anexos = value;
                    this.isEmpty = this.anexos.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    console.error('Erro ao carregar aba licenca', e);
                    this.$root.showMessage('error', 'msg-erro-ven-cliente-licenca-load');
                })
                .finally(() => {
                    this.isLoading = false;
                    if (this.fromDelete) {
                        this.fromDelete = false;
                    }
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            return body.content.map((m) => {
                return {
                    id: m.id,
                    caminho: m.caminho,
                    nome: m.nome,
                    datahora: m.datahora,
                };
            });
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
    },
};
</script>
<style lang="scss" scoped>
.upload-picker {
    height: 100px;
    margin: 12px;
    margin-bottom: 24px;
}
.img-anexo {
    height: 48px;
}
.data-table .ml-1 {
    margin-left: 0 !important;
}
</style>
